import React from 'react';
import { connect } from 'react-redux';
import {Grid, Row, Col} from 'react-bootstrap';
import Layout from '../../components/layout/Layout';
import Card from '../../components/card/Card';
import { appendEvaluationCriteriaParams, defaultRejectHandler } from '../../utils/utility';
import { translate } from 'react-i18next';

import { listProjectLocation } from '../../redux/projects/project_location_actions';
import { listBuildingType } from '../../redux/building_type/building_type_actions';
import { listProvinces } from '../../redux/provinces/province_actions';
import { listEvaluationPurpose } from '../../redux/references/evaluation_purpose_actions';
import {
  getProjectStats,
  getOttvStats,
  getRttvStats,
  getLpdStats,
  getCopStats,
  getSeerStats,
  getBoilerStats,
  getHotWaterCopStats,
  getPveStats,
  getHeeStats,
  getOtherReStats,
  getLightingPowerStats,
  clearAllStats,
} from '../../redux/stat/stat_actions';

import '../../components/default.css';
import SummaryCard from '../../components/summarycard/SummaryCard';
import StatChartTab from '../../components/charts/StatChartTab';
import { Button, Form, FormGroup, ControlLabel, FormControl, Tabs, Tab } from 'react-bootstrap';
import Constants from '../../config/constants';
import ErrorModal from '../../modal/util/ErrorModal';
import axios from 'axios';
import { serializeParams } from '../../utils/rest-service';

const CHART_CONFIGS = [
  {
    eventKey: 'ottv',
    tabTitle: 'OTTV',
    chartTitleTh: 'ค่าการถ่ายเทความร้อนรวมของผนังด้านนอกอาคาร (OTTV)',
    chartTitleEn: 'Overall Thermal Transfer Value; OTTV',
    yAxisLabel: 'OTTV (W/m²)',
    dataKey: 'ottvData',
    loadingKey: 'ottvLoading',
    color: '#5B8FF9',
  },
  {
    eventKey: 'rttv',
    tabTitle: 'RTTV',
    chartTitleTh: 'ค่าการถ่ายเทความร้อนรวมของหลังคาอาคาร (RTTV)',
    chartTitleEn: 'Roof Thermal Transfer Value; RTTV',
    yAxisLabel: 'RTTV (W/m²)',
    dataKey: 'rttvData',
    loadingKey: 'rttvLoading',
    color: '#61DDAA',
  },
  {
    eventKey: 'lpd',
    tabTitle: 'LPD',
    chartTitleTh: 'ค่ากำลังไฟฟ้าส่องสว่างสูงสุด (LPD)',
    chartTitleEn: 'Lighting power density; LPD',
    yAxisLabel: 'LPD (W/m²)',
    dataKey: 'lpdData',
    loadingKey: 'lpdLoading',
    color: '#65789B',
  },
  {
    eventKey: 'lightingPower',
    tabTitleTh: 'กำลังไฟฟ้าแสงสว่าง',
    tabTitleEn: 'Lighting Power',
    chartTitleTh: 'ค่ากำลังไฟฟ้าของระบบไฟฟ้าแสงสว่าง',
    chartTitleEn: 'Lighting system power',
    yAxisLabelTh: 'กิโลวัตต์',
    yAxisLabelEn: 'kW',
    dataKey: 'lightingPowerData',
    loadingKey: 'lightingPowerLoading',
    color: '#F6BD16',
    avgSuffix: ' kW',
  },
  {
    eventKey: 'cop',
    tabTitle: 'COP',
    chartTitleTh: 'ค่าสัมประสิทธิ์สมรรถนะขั้นต่ำของอาคาร (COP)',
    chartTitleEn: 'Coefficient of performance; COP',
    yAxisLabel: 'COP',
    dataKey: 'copData',
    loadingKey: 'copLoading',
    color: '#7262FD',
  },
  {
    eventKey: 'seer',
    tabTitle: 'SEER',
    chartTitleTh: 'ค่าประสิทธิภาพพลังงานตามฤดูกาล (SEER)',
    chartTitleEn: 'Seasonal energy efficiency ratio; SEER',
    yAxisLabel: 'SEER',
    dataKey: 'seerData',
    loadingKey: 'seerLoading',
    color: '#78D3F8',
  },
  {
    eventKey: 'boiler',
    tabTitle: 'Boiler',
    chartTitleTh: 'ค่าประสิทธิภาพขั้นต่ำของหม้อไอน้ำ (Boiler)',
    chartTitleEn: 'Minimum efficiency of boiler',
    yAxisLabel: '%',
    dataKey: 'boilerData',
    loadingKey: 'boilerLoading',
    color: '#F6903D',
    avgSuffix: '%',
  },
  {
    eventKey: 'hotWaterCop',
    tabTitleTh: 'COP น้ำร้อน',
    tabTitleEn: 'Hot Water COP',
    chartTitleTh: 'ค่าสัมประสิทธิ์สมรรถนะขั้นต้นของน้ำร้อน (ฮีตปั๊ม)',
    chartTitleEn: 'Initial COP of hot water (heat pump)',
    yAxisLabel: 'COP',
    dataKey: 'hotWaterCopData',
    loadingKey: 'hotWaterCopLoading',
    color: '#F08BB4',
  },
  {
    eventKey: 'pv',
    tabTitleTh: 'พลังงานแสงอาทิตย์',
    tabTitleEn: 'PV Energy',
    chartTitleTh: 'ค่าพลังงานหมุนเวียนที่ผลิตโดยเซลล์แสงอาทิตย์ (กิโลวัตต์ชั่วโมงต่อปี)',
    chartTitleEn: 'Renewable energy by PV (kWh/y)',
    yAxisLabel: 'kWh/y',
    dataKey: 'pveData',
    loadingKey: 'pveLoading',
    color: '#5AD8A6',
    avgSuffix: ' kWh/y',
  },
  {
    eventKey: 'heatToElec',
    tabTitleTh: 'ความร้อนเทียบไฟฟ้า',
    tabTitleEn: 'Heat to Electricity',
    chartTitleTh: 'ค่าพลังงานความร้อนหมุนเวียนเทียบเป็นพลังงานไฟฟ้า (กิโลวัตต์ชั่วโมงต่อปี)',
    chartTitleEn: 'Renewable heat to electricity (kWh/y)',
    yAxisLabel: 'kWh/y',
    dataKey: 'heeData',
    loadingKey: 'heeLoading',
    color: '#6DC8EC',
    avgSuffix: ' kWh/y',
  },
  {
    eventKey: 'otherRe',
    tabTitleTh: 'พลังงานหมุนเวียนอื่น',
    tabTitleEn: 'Other RE',
    chartTitleTh: 'ค่าพลังงานหมุนเวียนในรูปแบบอื่น ๆ (กิโลวัตต์ชั่วโมงต่อปี)',
    chartTitleEn: 'Other renewable energy (kWh/y)',
    yAxisLabel: 'kWh/y',
    dataKey: 'otherReData',
    loadingKey: 'otherReLoading',
    color: '#9270CA',
    avgSuffix: ' kWh/y',
  },
];

const CHART_GROUPS = [
  {
    groupKey: 'envelope',
    groupTitleTh: 'ระบบเปลือกอาคาร',
    groupTitleEn: 'Envelope System',
    charts: ['ottv', 'rttv'],
  },
  {
    groupKey: 'lighting',
    groupTitleTh: 'ระบบไฟฟ้าแสงสว่าง',
    groupTitleEn: 'Lighting System',
    charts: ['lpd', 'lightingPower'],
  },
  {
    groupKey: 'aircon',
    groupTitleTh: 'ระบบปรับอากาศ',
    groupTitleEn: 'Air Conditioning System',
    charts: ['cop', 'seer'],
  },
  {
    groupKey: 'hotWater',
    groupTitleTh: 'อุปกรณ์ผลิตน้ำร้อน',
    groupTitleEn: 'Water Heating Appliance',
    charts: ['boiler', 'hotWaterCop'],
  },
  {
    groupKey: 'renewable',
    groupTitleTh: 'พลังงานหมุนเวียน',
    groupTitleEn: 'Renewable Energy',
    charts: ['pv', 'heatToElec', 'otherRe'],
  },
];

const EVALUATION_STATUS_OPTIONS = [
  { id: 'all_passed', labelTh: 'ผ่านเกณฑ์ทั้งหมด', labelEn: 'Passed all criteria' },
  { id: 'system_passed', labelTh: 'ผ่านเกณฑ์รายระบบ', labelEn: 'Passed by system' },
  { id: 'energy_passed', labelTh: 'ผ่านเกณฑ์พลังงานโดยรวม', labelEn: 'Passed overall energy' },
  { id: 'both_failed', labelTh: 'ไม่ผ่านทั้งสองเกณฑ์', labelEn: 'Failed both criteria' },
];

class InspectionDashboardPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      projectId: this.props.match.params.projectId,
      isShowEditModal: false,
      isShowDeleteModal: false,
      isShowUploadImageModal: false,
      isShowErrorModal: false,
      errorMessage: null,
      selectedBuildingTypeIds: [],
      selectedProvinceIds: [],
      selectedEvaluationStatuses: [],
      selectedEvaluationPurposeIds: [],
      areaMin: '',
      areaMax: '',
      dateFrom: '',
      dateTo: '',
      openDropdown: null,
      activeGroupTab: 'envelope',
      filterExpanded: true,
    };

    this.loadFunctions = {
      ottv: params => this.props.getOttvStats(params),
      rttv: params => this.props.getRttvStats(params),
      lpd: params => this.props.getLpdStats(params),
      lightingPower: params => this.props.getLightingPowerStats(params),
      cop: params => this.props.getCopStats(params),
      seer: params => this.props.getSeerStats(params),
      boiler: params => this.props.getBoilerStats(params),
      hotWaterCop: params => this.props.getHotWaterCopStats(params),
      pv: params => this.props.getPveStats(params),
      heatToElec: params => this.props.getHeeStats(params),
      otherRe: params => this.props.getOtherReStats(params),
    };
  }

  componentDidMount() {
    this.props.listProjects();
    this.props.listBuildingTypes();
    this.props.listProvinces();
    this.props.listEvaluationPurpose();
    // this.props.getProjectStats(this.buildFilterParams());
    this.loadGroupData('envelope');
    document.addEventListener('mousedown', this.handleDocumentMouseDown);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleDocumentMouseDown);
  }

  handleDocumentMouseDown = (e) => {
    if (this.filterRef && !this.filterRef.contains(e.target)) {
      if (this.state.openDropdown) {
        this.setState({ openDropdown: null });
      }
    }
  }

  componentWillReceiveProps(nextProps) {
  }

  buildFilterParams() {
    const params = {
      status: 'SUB',
    };

    // Arrays are serialized as repeated params by serializeParams:
    // province_id=1&province_id=2 (Django getlist format)
    if (this.state.selectedProvinceIds.length > 0) {
      params.province_id = this.state.selectedProvinceIds;
    }
    if (this.state.selectedBuildingTypeIds.length > 0) {
      params.building_type_id = this.state.selectedBuildingTypeIds;
    }
    appendEvaluationCriteriaParams(params, this.state.selectedEvaluationStatuses);
    if (this.state.selectedEvaluationPurposeIds.length > 0) {
      params.evaluation_purpose = this.state.selectedEvaluationPurposeIds;
    }
    if (this.state.areaMin !== '') {
      params.area_min = this.state.areaMin;
    }
    if (this.state.areaMax !== '') {
      params.area_max = this.state.areaMax;
    }
    if (this.state.dateFrom) {
      params.date_from = this.state.dateFrom;
    }
    if (this.state.dateTo) {
      params.date_to = this.state.dateTo;
    }

    return params;
  }

  loadTabData(tabKey) {
    const params = this.buildFilterParams();
    const config = CHART_CONFIGS.find(c => c.eventKey === tabKey);
    if (!config) return;

    const data = this.props[config.dataKey];
    const loading = this.props[config.loadingKey];
    const loadFn = this.loadFunctions[tabKey];

    if (!data && !loading && loadFn) {
      loadFn(params);
    }
  }

  loadTabDataForced(tabKey) {
    const params = this.buildFilterParams();
    const loadFn = this.loadFunctions[tabKey];
    if (loadFn) {
      loadFn(params);
    }
  }

  loadGroupData(groupKey) {
    const group = CHART_GROUPS.find(g => g.groupKey === groupKey);
    if (!group) return;
    group.charts.forEach(chartKey => this.loadTabData(chartKey));
  }

  loadGroupDataForced(groupKey) {
    const group = CHART_GROUPS.find(g => g.groupKey === groupKey);
    if (!group) return;
    group.charts.forEach(chartKey => this.loadTabDataForced(chartKey));
  }

  handleGroupTabSelect = (groupKey) => {
    this.setState({ activeGroupTab: groupKey }, () => {
      this.loadGroupData(groupKey);
    });
  }

  renderActionMenu() {
    return [];
  }

  handleSearch = () => {
    this.props.clearAllStats();
    setTimeout(() => {
      // this.props.getProjectStats(this.buildFilterParams());
      this.loadGroupDataForced(this.state.activeGroupTab);
    }, 0);
  }

  handleClearFilters = () => {
    this.setState({
      selectedBuildingTypeIds: [],
      selectedProvinceIds: [],
      selectedEvaluationStatuses: [],
      selectedEvaluationPurposeIds: [],
      areaMin: '',
      areaMax: '',
      dateFrom: '',
      dateTo: '',
      openDropdown: null,
    }, () => {
      this.props.clearAllStats();
      setTimeout(() => {
        // this.props.getProjectStats(this.buildFilterParams());
        this.loadGroupDataForced(this.state.activeGroupTab);
      }, 0);
    });
  }

  handleExportReport = () => {
    const params = this.buildFilterParams();
    const accessToken = localStorage.getItem('access-token');
    const headers = {};
    if (accessToken) {
      headers['Authorization'] = `Token ${accessToken}`;
    }

    axios({
      method: 'get',
      url: Constants.API_PROJECT_STAT_REPORT,
      params: params,
      paramsSerializer: serializeParams,
      headers: headers,
      responseType: 'blob',
    })
      .then(response => {
        const contentDisposition = response.headers['content-disposition'];
        let filename = 'report.xlsx';
        if (contentDisposition) {
          const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (match && match[1]) {
            filename = match[1].replace(/['"]/g, '');
          }
        }
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
      })
      .catch(err => {
        console.error('Export error:', err);
        this.setState({
          isShowErrorModal: true,
          errorMessage: 'ไม่สามารถออกรายงานได้ / Export failed',
        });
      });
  }

  // Export the project list (27-column "Projects" sheet) via project/export/
  handleExportProjectList = () => {
    const params = this.buildFilterParams();
    const accessToken = localStorage.getItem('access-token');
    const headers = {};
    if (accessToken) {
      headers['Authorization'] = `Token ${accessToken}`;
    }

    axios({
      method: 'get',
      url: Constants.API_PROJECT_EXPORT,
      params: params,
      paramsSerializer: serializeParams,
      headers: headers,
      responseType: 'blob',
    })
      .then(response => {
        const contentDisposition = response.headers['content-disposition'];
        let filename = 'projects_export.xlsx';
        if (contentDisposition) {
          const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (match && match[1]) {
            filename = match[1].replace(/['"]/g, '');
          }
        }
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
      })
      .catch(err => {
        console.error('Export error:', err);
        this.setState({
          isShowErrorModal: true,
          errorMessage: 'ไม่สามารถออกรายงานได้ / Export failed',
        });
      });
  }

  dismissErrorModal = () => {
    this.setState({ isShowErrorModal: false, errorMessage: null });
  }

  // Render a multi-select checkbox dropdown
  renderMultiSelectDropdown({ dropdownKey, options, selectedIds, onToggle, getLabel, allLabelTh, allLabelEn }) {
    const lang = this.props.i18n.language.split('-')[0];
    const l = (th, en) => (lang === 'th' ? th : en);
    const isOpen = this.state.openDropdown === dropdownKey;
    const displayText = selectedIds.length === 0
      ? l(allLabelTh || 'ทั้งหมด', allLabelEn || 'All')
      : `${selectedIds.length} ${l('รายการ', 'selected')}`;

    const dropdownStyle = {
      position: 'absolute',
      top: '100%',
      left: 0,
      right: 0,
      zIndex: 1050,
      backgroundColor: '#fff',
      border: '1px solid #ccc',
      borderRadius: 4,
      maxHeight: 220,
      overflowY: 'auto',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    };

    const itemStyle = {
      padding: '6px 12px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      userSelect: 'none',
    };

    const handleToggleAll = () => {
      onToggle([]);
      this.setState({ openDropdown: null });
    };

    const handleToggleItem = (id) => {
      const idStr = String(id);
      const newIds = selectedIds.includes(idStr)
        ? selectedIds.filter(x => x !== idStr)
        : [...selectedIds, idStr];
      onToggle(newIds);
    };

    return (
      <div style={{ position: 'relative' }}>
        <button
          type="button"
          className="form-control"
          style={{ textAlign: 'left', cursor: 'pointer', background: '#fff' }}
          onClick={() => this.setState({ openDropdown: isOpen ? null : dropdownKey })}
        >
          {displayText}
          <span style={{ float: 'right', color: '#999' }}>▾</span>
        </button>
        {isOpen && (
          <div style={dropdownStyle}>
            <div
              style={{ ...itemStyle, borderBottom: '1px solid #eee', fontWeight: 500 }}
              onClick={handleToggleAll}
            >
              <input
                type="checkbox"
                readOnly
                checked={selectedIds.length === 0}
                style={{ marginRight: 4 }}
              />
              {l('ทั้งหมด', 'All')}
            </div>
            {options.map(opt => {
              const idStr = String(opt.id);
              return (
                <div
                  key={opt.id}
                  style={itemStyle}
                  onClick={() => handleToggleItem(opt.id)}
                >
                  <input
                    type="checkbox"
                    readOnly
                    checked={selectedIds.includes(idStr)}
                    style={{ marginRight: 4 }}
                  />
                  {getLabel(opt)}
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }

  /* renderSummaryCards() {
    const lang = this.props.i18n.language.split('-')[0];
    const l = (th, en) => (lang === 'th' ? th : en);
    const stats = this.props.projectStats;
    const toGWh = kwh => (kwh == null ? null : (kwh / 1e6));
    const toKtoe = kwh => (kwh == null ? null : (kwh / 11630000));
    const toMillionBaht = baht => (baht == null ? null : (baht / 1e6));
    const toTonsCO2 = val => (val == null ? null : (val / 1e6));

    const savingEnergyKWh = stats && stats.totals ? stats.totals.saving_energy  : null;
    const costSaving = stats && stats.totals ? stats.totals.cost_saving : null;
    const co2Reduction = stats && stats.totals ? stats.totals.co2_reduction : null;

    const savingGWh = toGWh(savingEnergyKWh);
    const savingKtoe = toKtoe(savingEnergyKWh);
    const costSavingMillionBaht = toMillionBaht(costSaving);
    const co2ReductionTons = toTonsCO2(co2Reduction);

    const format = value => {
      if (value == null || isNaN(value)) return null;
      return value.toLocaleString(undefined, { maximumFractionDigits: 2 });
    };

    return (
      <Row className="show-grid">
        <Col xs={12} md={6} lg={3}>
          <SummaryCard
            title={l('ผลประหยัด', 'Savings')}
            iconClass="fas fa-bolt"
            number={format(savingGWh) || '-'}
            unit={l('GWh/ปี', 'GWh/y')}
            iconColor="#5B8FF9"
          />
        </Col>
        <Col xs={12} md={6} lg={3}>
          <SummaryCard
            title={l('ลดการใช้พลังงานไฟฟ้า', 'Reduced electricity consumption')}
            iconClass="fas fa-tint"
            number={format(savingKtoe) || '-'}
            unit={l('ktoe/ปี', 'ktoe/y')}
            iconColor="#61DDAA"
          />
        </Col>
        <Col xs={12} md={6} lg={3}>
          <SummaryCard
            title={l('ประหยัดค่าใช้จ่าย', 'Cost saving')}
            iconClass="fas fa-piggy-bank"
            number={format(costSavingMillionBaht) || '-'}
            unit={l('ล้านบาท/ปี', 'million THB/y')}
            iconColor="#F6903D"
          />
        </Col>
        <Col xs={12} md={6} lg={3}>
          <SummaryCard
            title={l('ลดการใช้ก๊าซ CO₂', 'CO₂ reduction')}
            iconClass="fas fa-cloud"
            number={format(co2ReductionTons) || '-'}
            unit={l('tons CO₂/ปี', 'tons CO₂/y')}
            iconColor="#F5222D"
          />
        </Col>
      </Row>
    );
  } */

  renderFilterBar() {
    const lang = this.props.i18n.language.split('-')[0];
    const l = (th, en) => (lang === 'th' ? th : en);
    const buildingTypeLabel = bt => bt[`name_${lang}`] || bt.name || bt.label || '';
    const purposeLabel = ep => ep[`name_${lang}`] || ep.name || ep.label || '';
    const { filterExpanded } = this.state;

    const filterHeader = (
      <div
        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer', userSelect: 'none' }}
        onClick={() => this.setState({ filterExpanded: !filterExpanded })}
      >
        <span>{l('ตัวกรอง (Filter)', 'Filter')}</span>
        <i
          className={`fas fa-chevron-${filterExpanded ? 'up' : 'down'}`}
          style={{ color: '#888', transition: 'transform 0.2s' }}
        />
      </div>
    );

    return (
      <Row className="show-grid">
        <Col xs={12}>
          <Card header={filterHeader} padding={true}>
            <div ref={el => { this.filterRef = el; }}>
              <div style={{
                overflow: 'hidden',
                maxHeight: filterExpanded ? 600 : 0,
                opacity: filterExpanded ? 1 : 0,
                transition: 'max-height 0.3s ease, opacity 0.2s ease',
              }}>
              <Form horizontal>
                {/* Row 1: Building Type | Province */}
                <FormGroup>
                  <Col componentClass={ControlLabel} sm={2}>{l('ประเภทอาคาร', 'Building type')}</Col>
                  <Col sm={4}>
                    {this.renderMultiSelectDropdown({
                      dropdownKey: 'buildingType',
                      options: this.props.buildingTypes,
                      selectedIds: this.state.selectedBuildingTypeIds,
                      onToggle: ids => this.setState({ selectedBuildingTypeIds: ids }),
                      getLabel: buildingTypeLabel,
                    })}
                  </Col>
                  <Col componentClass={ControlLabel} sm={2}>{l('จังหวัด', 'Province')}</Col>
                  <Col sm={4}>
                    {this.renderMultiSelectDropdown({
                      dropdownKey: 'province',
                      options: this.props.provinces,
                      selectedIds: this.state.selectedProvinceIds,
                      onToggle: ids => this.setState({ selectedProvinceIds: ids }),
                      getLabel: pv => pv.name || '',
                    })}
                  </Col>
                </FormGroup>

                {/* Row 2: Evaluation Status | Evaluation Purpose */}
                <FormGroup>
                  <Col componentClass={ControlLabel} sm={2}>{l('สถานะการประเมิน', 'Evaluation status')}</Col>
                  <Col sm={4}>
                    {this.renderMultiSelectDropdown({
                      dropdownKey: 'evalStatus',
                      options: EVALUATION_STATUS_OPTIONS,
                      selectedIds: this.state.selectedEvaluationStatuses,
                      onToggle: ids => this.setState({ selectedEvaluationStatuses: ids }),
                      getLabel: opt => l(opt.labelTh, opt.labelEn),
                    })}
                  </Col>
                  <Col componentClass={ControlLabel} sm={2}>{l('เหตุผลของการประเมิน', 'Evaluation purpose')}</Col>
                  <Col sm={4}>
                    {this.renderMultiSelectDropdown({
                      dropdownKey: 'evalPurpose',
                      options: this.props.evaluationPurposes,
                      selectedIds: this.state.selectedEvaluationPurposeIds,
                      onToggle: ids => this.setState({ selectedEvaluationPurposeIds: ids }),
                      getLabel: purposeLabel,
                    })}
                  </Col>
                </FormGroup>

                {/* Row 3: Building Area min-max */}
                <FormGroup>
                  <Col componentClass={ControlLabel} sm={2}>{l('พื้นที่อาคาร (ตร.ม.)', 'Building area (m²)')}</Col>
                  <Col sm={4}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <FormControl
                        type="number"
                        placeholder={l('ต่ำสุด', 'Min')}
                        value={this.state.areaMin}
                        onChange={e => this.setState({ areaMin: e.target.value })}
                        min={0}
                        style={{ flex: 1 }}
                      />
                      <span style={{ color: '#666', flexShrink: 0 }}>–</span>
                      <FormControl
                        type="number"
                        placeholder={l('สูงสุด', 'Max')}
                        value={this.state.areaMax}
                        onChange={e => this.setState({ areaMax: e.target.value })}
                        min={0}
                        style={{ flex: 1 }}
                      />
                    </div>
                  </Col>
                </FormGroup>

                {/* Row 4: Date range */}
                <FormGroup>
                  <Col componentClass={ControlLabel} sm={2}>{l('ช่วงวันที่', 'Date range')}</Col>
                  <Col sm={4}>
                    <FormControl
                      type="date"
                      value={this.state.dateFrom}
                      onChange={e => this.setState({ dateFrom: e.target.value })}
                    />
                  </Col>
                  <Col componentClass={ControlLabel} sm={2}>{l('ถึง', 'To')}</Col>
                  <Col sm={4}>
                    <FormControl
                      type="date"
                      value={this.state.dateTo}
                      onChange={e => this.setState({ dateTo: e.target.value })}
                    />
                  </Col>
                </FormGroup>

                {/* Buttons */}
                <FormGroup>
                  <Col smOffset={2} sm={10}>
                    <Button bsStyle="primary" style={{ marginRight: 8 }} onClick={this.handleSearch}>
                      {l('ค้นหา', 'Search')}
                    </Button>
                    <Button style={{ marginRight: 8 }} onClick={this.handleClearFilters}>
                      {l('ล้างค่า', 'Clear')}
                    </Button>
                    <Button bsStyle="success" style={{ marginRight: 8 }} onClick={this.handleExportReport}>
                      <i className="fas fa-file-export" style={{ marginRight: 6 }} />
                      {l('ออกรายงานสถิติ', 'Export Stat Report')}
                    </Button>
                    <Button bsStyle="success" onClick={this.handleExportProjectList}>
                      <i className="fas fa-file-excel" style={{ marginRight: 6 }} />
                      {l('ออกรายงานโครงการ (Excel)', 'Export Projects (Excel)')}
                    </Button>
                  </Col>
                </FormGroup>
              </Form>
              </div>
            </div>
          </Card>
        </Col>
      </Row>
    );
  }

  renderChartGroupTabs() {
    const lang = this.props.i18n.language.split('-')[0];
    const l = (th, en) => (lang === 'th' ? th : en);

    return (
      <Tabs
        id="inspection-group-tabs"
        activeKey={this.state.activeGroupTab}
        onSelect={this.handleGroupTabSelect}
      >
        {CHART_GROUPS.map(group => {
          const chartsInGroup = CHART_CONFIGS.filter(c => group.charts.includes(c.eventKey));

          return (
            <Tab
              key={group.groupKey}
              eventKey={group.groupKey}
              title={l(group.groupTitleTh, group.groupTitleEn)}
            >
              <div style={{ paddingTop: 12 }}>
                {chartsInGroup.map(config => {
                  const yAxisLabel = config.yAxisLabel || l(config.yAxisLabelTh, config.yAxisLabelEn);
                  return (
                    <div key={config.eventKey} style={{ marginBottom: 16 }}>
                      <StatChartTab
                        chartTitleTh={config.chartTitleTh}
                        chartTitleEn={config.chartTitleEn}
                        yAxisLabel={yAxisLabel}
                        data={this.props[config.dataKey]}
                        loading={this.props[config.loadingKey]}
                        color={config.color}
                        avgSuffix={config.avgSuffix}
                        lang={lang}
                      />
                    </div>
                  );
                })}
              </div>
            </Tab>
          );
        })}
      </Tabs>
    );
  }

  render() {
    return (
      <Layout
        history={this.props.history}
        breadcrumbItems={[]}
        renderActionMenu={() => this.renderActionMenu()}
      >
        <ErrorModal
          show={this.state.isShowErrorModal}
          errorMessage={this.state.errorMessage}
          onHide={this.dismissErrorModal}
        />
        <Grid>
          {/* {this.renderSummaryCards()} */}
          {this.renderFilterBar()}
        </Grid>
        <Grid fluid style={{ paddingLeft: 20, paddingRight: 20 }}>
          <Row className="show-grid">
            <Col xs={12}>
              <div className="white-tabs">
                {this.renderChartGroupTabs()}
              </div>
            </Col>
          </Row>
        </Grid>
      </Layout>
    );
  }
}

const mapStateToProps = state => ({
  projects: state.projectLocation.orderedIds.map(id => state.projectLocation.objects[id]),
  isLoading: state.projectLocation.isLoading,
  errorMessage: state.project.errorMessage,
  buildingTypes: state.buildingType.orderedIds.map(id => state.buildingType.buildingTypes[id]),
  buildingTypesLoading: state.buildingType.loading,
  provinces: state.province.orderedIds.map(id => state.province.provinces[id]),
  provincesLoading: state.province.loading,
  evaluationPurposes: state.reference.evaluationPurpose.evaluationPurposes,
  evaluationPurposesLoading: state.reference.evaluationPurpose.loading,
  projectStats: state.stat.projectStats,
  projectStatsLoading: state.stat.projectStatsLoading,
  ottvData: state.stat.ottvData,
  ottvLoading: state.stat.ottvLoading,
  rttvData: state.stat.rttvData,
  rttvLoading: state.stat.rttvLoading,
  lpdData: state.stat.lpdData,
  lpdLoading: state.stat.lpdLoading,
  copData: state.stat.copData,
  copLoading: state.stat.copLoading,
  seerData: state.stat.seerData,
  seerLoading: state.stat.seerLoading,
  boilerData: state.stat.boilerData,
  boilerLoading: state.stat.boilerLoading,
  hotWaterCopData: state.stat.hotWaterCopData,
  hotWaterCopLoading: state.stat.hotWaterCopLoading,
  pveData: state.stat.pveData,
  pveLoading: state.stat.pveLoading,
  heeData: state.stat.heeData,
  heeLoading: state.stat.heeLoading,
  otherReData: state.stat.otherReData,
  otherReLoading: state.stat.otherReLoading,
  lightingPowerData: state.stat.lightingPowerData,
  lightingPowerLoading: state.stat.lightingPowerLoading,
});

const mapDispatchToProps = dispatch => ({
  listProjects: () => defaultRejectHandler(dispatch(listProjectLocation())),
  listBuildingTypes: () => defaultRejectHandler(dispatch(listBuildingType())),
  listProvinces: () => defaultRejectHandler(dispatch(listProvinces())),
  listEvaluationPurpose: () => defaultRejectHandler(dispatch(listEvaluationPurpose())),
  getProjectStats: (params) => defaultRejectHandler(dispatch(getProjectStats(params))),
  getOttvStats: (params) => defaultRejectHandler(dispatch(getOttvStats(params))),
  getRttvStats: (params) => defaultRejectHandler(dispatch(getRttvStats(params))),
  getLpdStats: (params) => defaultRejectHandler(dispatch(getLpdStats(params))),
  getCopStats: (params) => defaultRejectHandler(dispatch(getCopStats(params))),
  getSeerStats: (params) => defaultRejectHandler(dispatch(getSeerStats(params))),
  getBoilerStats: (params) => defaultRejectHandler(dispatch(getBoilerStats(params))),
  getHotWaterCopStats: (params) => defaultRejectHandler(dispatch(getHotWaterCopStats(params))),
  getPveStats: (params) => defaultRejectHandler(dispatch(getPveStats(params))),
  getHeeStats: (params) => defaultRejectHandler(dispatch(getHeeStats(params))),
  getOtherReStats: (params) => defaultRejectHandler(dispatch(getOtherReStats(params))),
  getLightingPowerStats: (params) => defaultRejectHandler(dispatch(getLightingPowerStats(params))),
  clearAllStats: () => dispatch(clearAllStats()),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(InspectionDashboardPage),
);



// WEBPACK FOOTER //
// ./src/pages/inspection_dashboard/InspectionDashboardPage.js